import axios from 'axios';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  SnippetsOutlined,
} from '@ant-design/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { SidebarContext } from '../../layouts/Technician';

import styles from './index.module.scss';
import './index.module.scss';
import { Badge } from 'antd';
import {
  ORDER_SERVICE_STATUS_TEXT,
  ORDER_SERVICE_STATUS_COLOR,
} from '../../reducers/actions/orderService';

interface Props {
  header?: string;
}

interface OrderService {
  _id: string;
  user: string;
  applyJob: string;
  description: string;
  customer: {
    name: string;
    phone: string;
    address: string;
    province: string;
    district: string;
    subDistrict: string;
    postCode: string;
    lat: number;
    lng: number;
  };
  images: Object[];
  orderNo: string;
  category: string;
  status: string;
  updatedAt: string;
  createdAt: string;
}

interface Category {
  key: string;
  name: string;
  icon?: string;
}

const dateFormat = (datetime: any) => {
  return moment(new Date(datetime))
    .add(543, 'year')
    .format('DD/MM/YYYY');
};

const TechnicianSidebar: React.FC<Props> = () => {
  const navigate = useNavigate();
  const { currentItem, setCurrentItem, currentPage } =
    useContext(SidebarContext);
  const pageType = useSelector(() => {
    const page = currentPage?.split('-')[0];
    return page || 'orders';
  });

  const [orders, setOrders] = useState<OrderService[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<Boolean>(true);

  const getOrders = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        '/order-service-jobs?type=technician'
      );
      setOrders(data?.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getCategories = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/applyJobs/category');
      setCategories(data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const formatcategory = (category: string) => {
    let target = categories.find((cat) => cat.key === category);
    return target?.name || '';
  };

  const formatStatus = (status: any) => {
    let label = '';
    let icon: JSX.Element;
    switch (status) {
      case 'ACCEPT':
        label = 'ยังไม่สร้างใบเสนอราคา';
        icon = <PlusCircleOutlined className={styles[status]} />;
        break;
      case 'QUOTATION_DRAFT':
        label = 'บันทึกแบบร่างใบเสนอราคา';
        icon = <SnippetsOutlined className={styles[status]} />;
        break;
      case 'CUSTOMER_REVISE':
        label = 'เจ้าของบ้านต่อรองใบเสนอราคา';
        icon = <CloseCircleOutlined className={styles[status]} />;
        break;
      case 'QUOTATION_SENT':
        label = 'สร้างใบเสนอราคา';
        icon = <CheckCircleOutlined className={styles[status]} />;
        break;
      case 'CUSTOMER_ACCEPT':
        label = 'เจ้าของบ้านตอบรับ';
        icon = <CheckCircleOutlined className={styles[status]} />;
        break;
      default:
        icon = <></>;
        break;
    }

    return (
      <>
        {label ? (
          <div
            className={[
              styles.categoryStatus,
              styles[`cat-${status}`],
            ].join(' ')}
          >
            <span className={styles.statusIcon}>{icon}</span>
            <span>{label}</span>
          </div>
        ) : (
          ''
        )}
      </>
    );
  };

  useEffect(() => {
    getCategories();
    getOrders();
  }, []);

  const handleItemClick = (id: string) => {
    setCurrentItem(id);
    navigate(`${pageType}/${id}`);
  };

  useEffect(() => {
    if (orders.length > 0) {
      handleItemClick(orders[0].orderNo);
    }
  }, [orders]);

  const Orders = () => {
    return (
      <div className={styles.ordersContainer}>
        {orders.map((order) => (
          <Badge.Ribbon
            text={ORDER_SERVICE_STATUS_TEXT[order.status]}
            color={ORDER_SERVICE_STATUS_COLOR[order.status]}
          >
            <div
              key={`${order.orderNo}`}
              className={[
                styles.sidebarItem,
                currentItem === order.orderNo ? styles.selected : '',
              ].join(' ')}
              onClick={() => handleItemClick(order.orderNo)}
            >
              <div className={styles.infoWrapper}>
                <div>
                  <div className={styles.subText}>
                    {order.orderNo}
                  </div>
                  <div className={styles.subText}>
                    {dateFormat(order.updatedAt)}
                  </div>
                </div>
                {order.status && pageType === 'invoices' ? (
                  <>{formatStatus(order.status)}</>
                ) : (
                  ''
                )}
              </div>
              <div className={styles.categoryName}>
                {formatcategory(order.category)}
              </div>
            </div>
          </Badge.Ribbon>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className={styles.technicianSidebarContainer}>
        {loading ? (
          <div style={{ textAlign: 'center' }}>
            <LoadingOutlined />
          </div>
        ) : (
          <Orders />
        )}
      </div>
    </>
  );
};

export default TechnicianSidebar;
